function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#808285;}.cls-3{fill:#04acde;}.cls-4{fill:#a8cae1;}.cls-5{fill:#c1d8e9;}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "19-telegram",
  id: "_19-telegram"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  height: 64,
  rx: 11.2,
  ry: 11.2,
  width: 64
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M52.8,1.07A10.14,10.14,0,0,1,62.93,11.2V52.8A10.14,10.14,0,0,1,52.8,62.93H11.2A10.14,10.14,0,0,1,1.07,52.8V11.2A10.14,10.14,0,0,1,11.2,1.07H52.8M52.8,0H11.2A11.19,11.19,0,0,0,0,11.2V52.8A11.19,11.19,0,0,0,11.2,64H52.8A11.19,11.19,0,0,0,64,52.8V11.2A11.19,11.19,0,0,0,52.8,0Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 32,
  cy: 32,
  r: 28
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "26.4 46.2 33.1 40.6 27.33 37.69 26.4 46.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M45.43,20.56,14.78,32a.8.8,0,0,0,.06,1.52l11,3.15a.87.87,0,0,1,.27.14l13.8,10.6a.8.8,0,0,0,1.27-.47l5.3-25.41A.8.8,0,0,0,45.43,20.56Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "23.24 35.88 26.4 46.2 27.33 37.69 41.8 24.7 23.24 35.88"
}));

function SvgTelegramIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegramIcon.7b13caec8d2562fa8a59b02bbfd075f2.svg";
export { ForwardRef as ReactComponent };